import { useContext, useRef, useState } from "react";
import { Label } from "../../../stories/Label/Label";
import TextArea from "../../../stories/TextArea/TextArea";
import JunctionDetails from "./common/JunctionDetails";
import TicketDetails from "./TicketDetails";
import {
  EMPTY_STRING,
  emptyFunc,
  emptyMessage,
  ticketRaiseResonOptions,
} from "../../../utils/constants";
import { useMutation } from "@apollo/client";
import { Operation } from "../../../utils/Enum.types";
import {
  AddTransformTicketResult,
  AddTransformTicketVar,
  AtsJunctionsOrderField,
} from "./queries/types";
import { AddTransformTicket } from "./queries/mutations";
import { OrderDirection } from "../../../utils/commonQueryTypes";
import { handleUploadAndDownloadFile } from "../../../utils/Upload";
import { payloadTypes } from "../../../context/reducer";
import { AppContext } from "../../../context/context";
import { toIsoDate } from "../../../utils/UtilFunctions";
import useServerDateandTimeWithoutToken from "../../../customHooks/useServerDateandTimeWithoutToken";
import { GetTransformNearByJunctions } from "./queries/queries";
import MessageModal from "../../../customComponents/MessageModal";
import LoadingModal from "../../pages/LoadingModal";
import Camera from "../../../images/Followup Icons/Camera.svg";
import { Autocomplete, TextField } from "@mui/material";
import { formClasses, labelClasses } from "../../../styles/AutocompleteStyles";
interface Props {
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const RaiseTicket = ({ setModal }: Props) => {
  const [raiseTicket, setRaiseTicket] = useState(false);
  const { state, dispatch } = useContext(AppContext);
  const { serverDate } = useServerDateandTimeWithoutToken();
  const [message, setMessage] = useState(emptyMessage);
  const [file, setFile] = useState<FileList | null>(null);
  const [formData, setFormData] = useState({
    remarks: "",
    reason: "",
  });
  const [progress, setProgress] = useState(0);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [modalFlag, setModalFlag] = useState(false);

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFile(event.target.files);
    const file = event.target.files?.[0];
    if (file && file.type.startsWith("image/")) {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
    } else {
      setPreviewUrl(null);
    }
  };

  const [addTransformTicket, { loading }] = useMutation<
    AddTransformTicketResult,
    AddTransformTicketVar
  >(AddTransformTicket, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const handleSubmit = () => {
    let filename = "";
    if (file) {
      const files = Object.values(file!);

      filename = files
        ? files.length > 1
          ? files.reduce((acc, itm) => {
              const seperators = itm.name.split("/");

              const filename = seperators[seperators.length - 1];

              acc = acc
                ? `${acc};${state.companyId}/ticketDetails/${filename}`
                : `${state.companyId}/ticketDetails/${filename}`;
              return acc;
            }, EMPTY_STRING)
          : `${state.companyId}/ticketDetails/${
              files[0].name.split("/")[files[0].name.split("/").length - 1]
            }`
        : EMPTY_STRING;

      if (state.junctionID) {
        setRaiseTicket(true);
        const addedPromise = addTransformTicket({
          variables: {
            customerID: state.customerId,
            input: {
              junctionID: state.junctionID,
              reason: formData.reason,
              remarks: formData.remarks,
              ticketDate: toIsoDate(serverDate),
              imagesPath: filename,
            },
          },
          refetchQueries: [
            {
              query: GetTransformNearByJunctions,
              variables: {
                longitude: state.longitude,
                latitude: state.latitude,
                after: null,
                first: 25,
                orderBy: {
                  direction: OrderDirection.DESC,
                  field: AtsJunctionsOrderField.NAME,
                },
                name: "",
              },
            },
          ],
        });

        addedPromise.then(({ data }) => {
          if (data && data.AddTransformTicket) {
            dispatch({
              type: payloadTypes.SET_TICKET,
              payload: {
                ticketId: data.AddTransformTicket.id,
              },
            });
            dispatch({
              type: payloadTypes.SET_JUNCTION_ID,
              payload: {
                junctionID: data.AddTransformTicket.junctionID,
              },
            });
            if (file) {
              const files = Object.values(file!);
              const uploadFilePromise = file
                ? Promise.all(
                    files.map((f, index) =>
                      handleUploadAndDownloadFile(
                        f,
                        file.length > 1
                          ? `${
                              data.AddTransformTicket.companyID
                            }/ticketDetails/${
                              data.AddTransformTicket.ticketDetails[0].id
                            }_${index}.${
                              f.name.split(".")[f.name.split(".").length - 1]
                            }`
                          : `${
                              data.AddTransformTicket.companyID
                            }/ticketDetails/${
                              data.AddTransformTicket.ticketDetails[0].id
                            }_0.${
                              f.name.split(".")[f.name.split(".").length - 1]
                            }`,
                        setProgress,
                        false
                      )
                    )
                  )
                : false;
              Promise.all([addedPromise, uploadFilePromise]).then(
                ([sendMsgData]) => {
                  if (sendMsgData) {
                    setFile(null);
                    setMessage({
                      flag: true,
                      message: "Ticket Raised Successfully",
                      operation: Operation.CREATE,
                    });
                    setRaiseTicket(false);
                  }
                }
              );
            } else {
              setMessage({
                flag: true,
                message: "Ticket Raised Successfully",
                operation: Operation.CREATE,
              });
            }
          }
        });
      }
    } else {
      setMessage({
        flag: true,
        message: "Attachment is required",
        operation: Operation.NONE,
      });
    }
  };

  const handleClear = () => {
    setFormData({
      reason: "",
      remarks: "",
    });
    setPreviewUrl(null);
    setFile(null);
  };

  const handleClose = () => {
    setMessage(emptyMessage);

    if (message.operation === Operation.CREATE) {
      setModalFlag(true);
      // dispatch({
      //   type: payloadTypes.SET_TICKET,
      //   payload: {
      //     ticketId: 0,
      //   },
      // });
      // dispatch({
      //   type: payloadTypes.SET_JUNCTION_ID,
      //   payload: {
      //     junctionID: 0,
      //   },
      // });
      handleClear();
    }
  };

  return (
    <div className="mobile-raise-ticket">
      {modalFlag ? (
        <TicketDetails setModal={setModal} />
      ) : (
        <>
          <div className="mobile-raise-ticket__signals">
            <div className="mobile-raise-ticket__signals--flex">
              <button
                className="mobile-signals--button"
                onClick={() => {
                  handleClear();
                  setModal(false);
                }}
              >
                Back
              </button>
              <div>
                {/* <span>Signal No</span>
                <b>{state.junctionID}</b> */}
              </div>
              <button
                onClick={() => {
                  handleClear();
                  setModal(false);
                }}
              >
                Change Signal
              </button>
            </div>
          </div>
          <JunctionDetails />

          <div className="mobile-raise-ticket__block">
            <div className="mobile-raise-ticket__block--autocomplete">
              <Label>Reason</Label>
              <Autocomplete
                options={ticketRaiseResonOptions}
                onKeyDown={emptyFunc}
                value={formData.reason}
                openOnFocus
                forcePopupIcon
                onChange={(e, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    reason: newValue ? newValue : "",
                  }));
                }}
                slotProps={{
                  paper: {
                    sx: {
                      backgroundColor: "#1e1e1e", // dropdown background
                      color: "white",
                    },
                  },
                  popper: {
                    sx: {
                      "& .MuiAutocomplete-listbox": {
                        padding: "3px", // padding for entire list
                      },
                      "& .MuiAutocomplete-option": {
                        padding: "5px", // custom option padding

                        "&.Mui-focused": {
                          backgroundColor: "#004d40", // hover/focus
                          color: "white",
                        },
                      },
                    },
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label={""}
                    autoFocus={false}
                  />
                )}
              />
            </div>
            <div className="mobile-raise-ticket__block--textarea">
              <Label>Remarks</Label>
              <TextArea
                rows={3}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    remarks: e.target.value,
                  }));
                }}
                value={formData.remarks}
              />
            </div>
            <div className="mobile-raise-ticket__block--camera">
              <Label>Photos</Label>

              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
                accept="jpg, .png, .jpeg"
                capture="environment"
              />
              <div
                className="mobile-raise-ticket__block--camera--block"
                onClick={handleButtonClick}
              >
                <img
                  src={Camera}
                  alt=""
                  className="mobile-raise-ticket__block--camera--block--image"
                />
                {previewUrl && <img src={previewUrl} alt="Preview" />}
              </div>
              {/* <div
                className="mobile-raise-ticket__block--camera--block"
                onClick={() => setShowCamera((prev) => !prev)}
              >
                {showCamera && (
                  <Webcam
                  //  onChange={(
                  //   e: React.ChangeEvent<HTMLInputElement>
                  // ) => {
                  //   handleImagePreview(e);
                  //   setBrowse(!browse);
                  // }}
                  />
                )}
              </div>
             */}
            </div>
          </div>
          <div className="mobile-raise-ticket__button">
            <button
              className="mobile-raise-ticket__button--raise"
              onClick={handleSubmit}
              disabled={raiseTicket || loading}
            >
              Raise Ticket
            </button>
            <button
              className="mobile-raise-ticket__button--clear"
              onClick={handleClear}
            >
              Clear
            </button>
          </div>
          {/* <div className="mobile-raise-ticket__legends">
            <Legends />
          </div> */}
        </>
      )}

      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />
      <LoadingModal
        flag={raiseTicket || loading}
        message="Creating..."
        forMobile={true}
      />
    </div>
  );
};

export default RaiseTicket;
